// prettier-ignore
import { AfterViewInit, Component, ComponentFactoryResolver, OnInit,
  ViewChild, ViewContainerRef, Inject, ComponentRef, ChangeDetectorRef,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { skip } from 'rxjs';
import { DialogService } from '../dialog.service';
import { Env } from '@usimweb/core/models';

@Component({
  selector: 'usimweb-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  standalone: false,
})
export class DialogComponent implements OnInit, AfterViewInit {
  @ViewChild('entry', { read: ViewContainerRef }) entry!: ViewContainerRef;

  public component;

  public data;

  public title;

  public info;

  public owner = '';

  public ownerEmail = '';

  public leftBtn = 'Close';

  public rightBtn = 'Save';

  public isRightBtnDisabled = false;

  public isToUBanner = false;

  public text: string | string[];

  private componentRef!: ComponentRef<any>;

  public progress = false;

  public isToolBar = true;

  public multiText: string[] = [];

  public toULink = '';

  public headerColor: string;

  public isDraggable: boolean = true;

  constructor(
    @Inject('environment') environment: Env,
    private dialogService: DialogService,
    private dialogRef: MatDialogRef<DialogComponent>,
    private resolver: ComponentFactoryResolver,
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.headerColor = environment.headerColor;
    this.title = data.title;
    this.data = data.data;
    this.component = data.component;
    this.text = data.text;
    this.rightBtn = data.saveBtn;
    this.info = data.info;

    console.log(data.isDraggable);

    this.isDraggable = data.isDraggable === undefined ? true : data.isDraggable;

    this.isToUBanner = data?.data?.isToUBanner;

    this.toULink = 'https://ultrasimweb.basf.com/' + environment.APP + '/terms_of_use/';
  }

  ngOnInit(): void {
    if (this.data?.isToolBar !== undefined) {
      this.isToolBar = this.data.isToolBar;
    }

    if (Array.isArray(this.text)) {
      this.multiText = this.text;
    }

    this.dialogService.btnDisabler.pipe(skip(1)).subscribe((isDiabled) => {
      this.disableRightBtn(isDiabled);
    });

    this.dialogService.titleUpdater.pipe(skip(1)).subscribe((title) => {
      this.title = title;
      this.cd.detectChanges();
    });
  }

  ngAfterViewInit(): void {
    const componentFactoryResolver = this.resolver.resolveComponentFactory(this.component);
    this.componentRef = this.entry.createComponent(componentFactoryResolver);

    if (this.data) {
      this.componentRef.instance.data = this.data;
    }

    if (this.componentRef.instance.progressEmitter) {
      this.progress = true;
      this.componentRef.instance.progressEmitter.subscribe((progress: boolean) => {
        this.progress = progress;
      });
    }

    this.cd.detectChanges();
  }

  private responseHandler(closeOption: boolean) {
    if (this.componentRef.instance.saveResponse) {
      this.componentRef.instance.save();
      this.componentRef.instance.saveResponse
        //  pipe creates some issues if custom save is enabled
        //  user need to click twice to close the dialog...
        // .pipe(skip(1))
        .subscribe((data: any) => {
          if (data) {
            this.dialogRef.close(data);
          }
        });
    } else {
      this.dialogRef.close(closeOption);
    }
  }

  public close() {
    //this.responseHandler(false);
    //this.dialogRef.close();
    this.componentRef.instance.close();
  }

  public save() {
    if (this.rightBtn) {
      this.componentRef.instance.save();
    }
  }

  public hideRightBtn() {
    this.rightBtn = '';
  }

  public disableRightBtn(isDisabled: boolean) {
    this.isRightBtnDisabled = isDisabled;
    this.cd.detectChanges();
  }
}
